import { createFileRoute, redirect } from '@tanstack/react-router'

import { isLandingEnabled } from 'lib/landingFlag'
import { requireAuth } from 'lib/routeGuards'

import Home from 'pages/Home'
import { LandingPage } from 'pages/Landing'

// The landing page is intentionally public -- it's the marketing site shown to
// unauthenticated visitors. The `isLandingEnabled()` flag gates internal preview
// rollout (feature flag / env var), not access control. When the flag is off,
// the root route falls back to the authenticated Home dashboard.
export const Route = createFileRoute('/')({
  beforeLoad: (args) => {
    if (isLandingEnabled()) {
      // Authenticated users go to their home page, not the marketing page
      if (args.context.auth.currentUser) {
        const home = args.context.auth.routing.home || '/search'
        throw redirect({ to: home })
      }
    } else {
      requireAuth(args)
    }
  },
  component: () => {
    if (isLandingEnabled()) {
      return <LandingPage slug='default' />
    }
    return <Home />
  },
})
